import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2';
import moment from 'moment';

import IconSave from 'react-icons/lib/md/save';

import * as actions from '../../actions/ticket';

import Select from 'react-select';

import {api, API_URL} from '../../actions/_request';
import ModalTablas from './../catalogos/modal_tablas.js'
import ReactTable from "react-table";
import "react-table/react-table.css";
const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };




class TicketModal extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {
            motivo:'01',
            sustituto_id:'',
            factura:[],
            motivos:[{label:'[01] Comprobante emitido con errores con relación',value:'01'},
                     {label:'[02] Comprobanteemitido con errores sin relación',value:'02'},
                     {label:'[03] No se llevó acabo la operación',value:'03'},
                     {label:'[04] Operación nominativa relacionada en la factura global',value:'04'},],
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.delete = this.delete.bind(this);
        this.push = this.push.bind(this);
	}
    push(){
        let {cc,cc_text} = this.state;
       if(cc_text.length>0){
        // 
        let emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        //Se muestra un texto a modo de ejemplo, luego va a ser un icono
        if (emailRegex.test(cc_text)) {
            cc.unshift({
            correo : cc_text,
              });
          this.setState({
            cc : cc,
            cc_text:'',
        });
        } else {
           swal("Oops..", "Correo Invalido ");
        }

         

       }
       

    }
    delete(evt,index){
        let {cc} = this.state;  

        cc.splice(index,1);
        this.setState({
          cc : cc,
        });
    }
    handleInputChange(event) {
        let {impuesto} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        this.setState({
           [name] : value,
        });
    }

    componentDidMount()
    {


        let self=this;


        /*determinamos que tabla vamos a buscar si es facturas,completementos de pago ,notas de credito*/
        let tabla_modal=36;
        let tipo_movimiento_id=0;
        switch(this.props.documento.tipo_movimiento_id){
            case 1:
                tabla_modal=37;
                tipo_movimiento_id=1;
            break
            case 2:
                tabla_modal=37;
                tipo_movimiento_id=2;
            break
        }


        self.setState({
            tabla_modal:tabla_modal,
            tipo_movimiento_id:tipo_movimiento_id,
            factura: this.props.documento,

        });   


       
      
    }

    

    

    handleSelectChange(select, name) {
  
        const value = select === null ? null : select.value;
        console.log('value--->',value)
        console.log('campo--->',name)

        this.setState({ 
                [name]: value,
                sustituto_id:'',
        });
    }

    

	handleSubmit(evt)
	{
        let {motivo,sustituto_id,factura} = this.state;
        let self=this;
		evt.preventDefault();
        /*tenemos que validar  si el motivo es 01  entonces tenemos que asignar una facturar sustito*/
        if(motivo=='01'&&sustituto_id==''){
            /*error*/
             swal("Atención", "Con el Motivo [01] Comprobante emitido con errores con relación se tiene que Asignar un Facturar   ", "warning");
            return
        }


        factura.motivo_cancelacion=motivo;
        factura.sustituto_id=sustituto_id;


        /*hacemos la llamada para la cancelacion*/
        swal.queue([{
        title: 'Estas seguro?',
        text: `Se Cacelara la  ${this.props.tipo}`+factura.factura+" para "+factura.cliente+' Por la cantidad de '+factura.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().post(`/${self.props.ruta}/`+factura.value, factura)
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  // console.log('entor al status 200');
                  console.log('response.data-->',response.data) ;
                  if(parseInt(response.data.estado)==200){
                     swal.insertQueueStep({
                      type: 'success',
                      title: `La ${self.props.tipo} Fue Cancelada`
                    })



                     // console.log('self.props-->',self.props) ;
                     if(self.state.tipo_movimiento_id>0){
                        self.props.retorno(response.data.movimiento);
                     }else{
                        self.props.retorno(response.data.factura);
                     }
                     
                  }
                   if(parseInt(response.data.estado)==210){
                     swal.insertQueueStep({
                      type: 'error',
                      title: 'La Factura Cuenta Con Abonos'
                    })
                  }
                  if(parseInt(response.data.estado)==500){
                    console.log('Mensaje de error--->',response.data.error.descripcion)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.error.descripcion
                      })

                   }
                 
                }
            })
            .catch((error) => {
                console.log('error--->',error)
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administradorffff',
              })
            })
        }
      }])


       
        
        

	}

    retorno=(factura)=>{
        console.log('retorno--->',factura)
        this.setState({ 
                sustituto_id: factura.value,
                folio_sustituto_id:factura.factura?factura.factura:factura.referencia,
                modal:false,
        });


    }

    toggle_modal=(index=0,catalogo="",campo="")=>{  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            
            campo_modal:campo,         
        })
    }

	render()
	{
       // console.log('lista de correos--->',this.state.cc);
       console.log('state--->',this.state);
       let {factura,motivo,sustituto_id,folio_sustituto_id}=this.state;
		
		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle} style={{}} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>Cancelación de {this.props.tipo}</ModalHeader>
                <ModalBody>
                    <div className="row mt-3 form_cliente">
                        <div className="col-md-8"> 
                    <div className="form-group">
                        <label >Motivo *:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="motivo"
                            options={this.state.motivos}
                            value={motivo}
                            onChange={ (select) => { this.handleSelectChange(select, 'motivo') } }
                            clearable={false}

                        />
                    </div>
                </div>
                {motivo=='01'&&
                <div className="col-12 col-sm-6 col-md-3"> 
                              <div className="">
                                <label className="">{this.props.tipo}: </label><br/>
                                <div style={{display : 'flex'}}>
                                  <input
                                    placeholder=""
                                    type="text"
                                    name="folio_sustituto_id"
                                    value={folio_sustituto_id}
                                    className="input_factura"
                                    readOnly
                                    required

                                  />
                                  <Button style={{height: '33px'}} onClick={ (button) => { this.toggle_modal(36,this.props.tipo+"s","sustituto_id") } } >...</Button>
                                 {/* <p className="ml-1">{factura.cliente_nombre}</p>*/}
                                </div>
                              </div>
                          </div>
                }

                </div>
                   
                    
                  
                    
                </ModalBody>
                <ModalFooter>
                    {
                    	this.state.submit ?
                    	<SubmitLoad /> : 
                    	<div>
                    		<Button color="primary" type="submit" >
                    			Cancelar
                    		</Button>{' '}
                    		<Button color="secondary" onClick={this.props.toggle}>
		                    	Atras
		                    </Button>
                    	</div>
                    }
                </ModalFooter>
                </form>

                 { this.state.modal&&
                    <ModalTablas
                        open={this.state.modal}
                        toggle={this.toggle_modal}                  
                        titulo={this.state.titulo}
                        catalogo={this.state.tabla_modal}
                        retorno={this.retorno}
                        tipo_movimiento_id={this.state.tipo_movimiento_id}
                        campo={this.state.campo_modal}
                        cliente_id={0}
                    />
                }
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        ticket : state.ticket,
    }
};

export default connect(mapStateToProps, actions)(TicketModal)


// WEBPACK FOOTER //
// ./src/components/ModalCancelacion/index.js